import auth0 from 'auth0-js'
import history from 'src/history'
import { Http } from 'helpers'
import { unregister } from 'src/registerServiceWorker'
import { AUTH_CONFIG, API, STORAGE_KEYS } from 'src/constants'

interface AuthResponse {
    access_token: string,
    id_token: string,
    expires_in: number,
    token_type: string
}

interface User {
    id: string,
    userName: string,
    active: boolean,
    role: string,
    permissions: Object[]
}

export default class Auth {

    public auth0 = new auth0.WebAuth({
        domain: AUTH_CONFIG.domain,
        clientID: AUTH_CONFIG.clientId,
        redirectUri: AUTH_CONFIG.callbackUrl,
        responseType: 'token id_token',
        scope: 'openid name roles email'
    })

    public login( formData: any) {

        return new Promise( (resolve, reject) => {

            const { username, password } = formData
            const requestData = {
               username, password
            }

            Http(API.currentHost + API.endpoints.login, 'POST', requestData)
                .then((authResult: AuthResponse) => {
                    this.setSession(authResult)
                    this.getAccount()
                        .then((response: User) => {
                            resolve(authResult)
                            history.replace('/search')
                    })
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    public getAccount() {

        return new Promise( (resolve, reject) => {
            Http(API.host + API.endpoints.account)
                .then((userData: User) => {
                    this.setAccount(userData)
                    resolve(userData)
                })
                .catch((error) => {
                    console.error(error)
                    reject(error)
                })
            })
    }

    public setAccount( user: User ) {
        localStorage.setItem(STORAGE_KEYS.ACCOUNT, JSON.stringify(user))
    }

    public setSession(authResult: AuthResponse) {
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify((authResult.expires_in * 1000) + new Date().getTime())
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, authResult.access_token)
        localStorage.setItem(STORAGE_KEYS.ID_TOKEN, authResult.id_token)
        localStorage.setItem(STORAGE_KEYS.EXPIRES, expiresAt)
    }

    public logout() {
        // Unregister service worker
        unregister()
        // Clear access token and ID token from local storage
        localStorage.removeItem(STORAGE_KEYS.ID_TOKEN)
        localStorage.removeItem(STORAGE_KEYS.EXPIRES)
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
        localStorage.removeItem(STORAGE_KEYS.ACCOUNT)
        localStorage.removeItem(STORAGE_KEYS.CLIENT)
        localStorage.removeItem(STORAGE_KEYS.BASKET_ITEMS)
        localStorage.removeItem(STORAGE_KEYS.SEARCH)
        // Go to Login
        history.replace('/login')
    }

    public isAuthenticated() {
        // Check whether the current time is past the
        // access token's expiry time
        let time = localStorage.getItem(STORAGE_KEYS.EXPIRES) || ''
        let expiresAt = (time.length > 0) ? JSON.parse(time) : new Date().getTime()
        return new Date().getTime() < expiresAt
    }
}



// WEBPACK FOOTER //
// ./src/services/Auth/index.tsx